import {
  Grid,
  makeStyles,
} from "@material-ui/core";
import { QuestionAnswer } from "@material-ui/icons";
import React, { ReactNode } from "react";
import { TranslationKey } from "../../translations/TranslationKey";
import TitleWithIcon from "../common/TitleWithIcon";

export const drawerWidth = 240;
export const navMenuLogoHeight = 120;
export const toolbarHeight = 64;

const useStyles = makeStyles((theme) => ({
  main: {
    rowGap: theme.spacing(1)+"px",
  },
}));

type TitleBarProps = {
  children: ReactNode;
  title: TranslationKey | string;
  variant: "h3" | "h4" | "h5";
};

const TitleBar: React.FunctionComponent<TitleBarProps> = ({ title, variant, children }) => {
  const classes = useStyles();
  return (
    <Grid item={true} container={true} alignItems="center" className={classes.main}>
      <Grid item={true} xs={12} sm={12} md={12} lg={5}>
        <TitleWithIcon title={title} variant={variant}>
          <QuestionAnswer />
        </TitleWithIcon>
      </Grid>
      <Grid item={true} xs={12} sm={12} md={12} lg={7}>
        {children}
      </Grid>
    </Grid>
  );
};

export default TitleBar;
